import React from 'react';
import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import { AlyceTheme } from '@alycecom/ui';

import useResponsive from '../../../../../hooks/useResponsive';

const useStyles = makeStyles<AlyceTheme, { headerHeight: number }>(() => ({
  content: ({ headerHeight }) => ({
    height: `calc(100vh - ${headerHeight}px)`,
    minHeight: `calc(100vh - ${headerHeight}px)`,
  }),
}));

export interface IAcceptLayoutProps {
  children: React.ReactNode;
  header: React.ReactNode;
  infoContent?: React.ReactNode;
  leftWidth?: number;
  rightWidth?: number;
}

const AcceptLayout = ({
  children,
  header,
  infoContent,
  leftWidth = 6,
  rightWidth = 6,
}: IAcceptLayoutProps): JSX.Element => {
  const { isMobile } = useResponsive();
  const headerHeight = isMobile ? 56 : 80;
  const classes = useStyles({ headerHeight });

  return (
    <>
      <Box>{header}</Box>
      <Grid
        className={classNames('accept-layout-ie', classes.content)}
        container
        display="flex"
        direction="row"
        justifyContent="center"
        alignItems="stretch"
      >
        {infoContent && (
          <Grid className="left-accept-block-ie" item xs={12} sm={leftWidth}>
            {infoContent}
          </Grid>
        )}
        <Grid item xs={12} sm={rightWidth}>
          {children}
        </Grid>
      </Grid>
    </>
  );
};

export default AcceptLayout;
